import { render, staticRenderFns } from "./ModattaStepInteractionDataPoint.vue?vue&type=template&id=e97c8726&scoped=true"
import script from "./ModattaStepInteractionDataPoint.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionDataPoint.vue?vue&type=script&lang=js"
import style0 from "./ModattaStepInteractionDataPoint.vue?vue&type=style&index=0&id=e97c8726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c8726",
  null
  
)

export default component.exports